import { useRef, useEffect } from "react";
import { gsap } from "gsap";

export default function Trust() {
    const compRef = useRef(null);

    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.from(".trust-logo", {
                scrollTrigger: {
                    trigger: compRef.current,
                    start: "top 90%",
                },
                y: 20,
                opacity: 0,
                stagger: 0.1,
                duration: 0.8,
                ease: "power2.out",
            });
        }, compRef);
        return () => ctx.revert();
    }, []);

    return (
        <section ref={compRef} className="bg-background py-16 border-t border-b border-dark/5 overflow-hidden">
            <div className="max-w-7xl mx-auto px-6">
                <p className="text-center font-mono text-xs uppercase text-dark/40 tracking-widest mb-8">
                    Pracujemy na materiałach i technologii sprawdzonych producentów
                </p>

                <div className="flex flex-wrap justify-center items-center gap-12 md:gap-20 opacity-60 grayscale hover:grayscale-0 transition-all duration-500">

                    <div className="trust-logo font-heading font-black text-2xl md:text-3xl tracking-widest uppercase text-dark">
                        ICOPAL
                    </div>

                    <div className="trust-logo font-heading font-bold text-2xl md:text-3xl text-dark tracking-wide uppercase">
                        IZOBUD
                    </div>

                    <div className="trust-logo font-heading font-bold text-xl md:text-2xl tracking-widest uppercase relative px-2">
                        <span className="absolute inset-0 bg-accent/20 skew-x-12"></span>
                        <span className="relative">LEMAR</span>
                    </div>

                    <div className="trust-logo font-mono font-bold text-xl md:text-2xl tracking-widest text-dark">
                        RUUKKI
                    </div>
                    
                    <div className="trust-logo font-heading font-bold text-xl md:text-2xl tracking-widest text-[#E3000F] uppercase">
                        BLACHOTRAPEZ
                    </div>

                    <div className="trust-logo font-heading font-black text-xl uppercase italic text-[#228B22]">
                        FAKRO
                    </div>

                </div>
            </div>
        </section>
    );
}
